import { useFormik, FormikHelpers } from "formik";
import { useDispatch } from "react-redux";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";

import { ComponentSignUpTel } from "@components";
import { IPhone } from "@interfaces";
import { authApi } from "@api";
import { setExternalLogin, setLoading } from "@redux";
import { useNotify } from "@utils";
import { enumExternalMethod, PATH_OTP } from "@configs";

export const ModuleTelSignUp = () => {
    //page hooks
    const dispatch = useDispatch();
    const { error, success } = useNotify();
    const { t } = useTranslation();
    const history = useHistory();
    //page state
    const [errorPhone, setError] = useState<string>();

    //page variable
    const initialValues: IPhone = {
        phoneNumber: "",
    };

    const handleRegister = async (values: IPhone, { setSubmitting }: FormikHelpers<IPhone>) => {
        if (errorPhone) return;
        if (!values.phoneNumber) {
            setError(t("validation.isNumber"));
            return;
        }

        try {
            setSubmitting(true);
            dispatch(setLoading(true));
            const res = await authApi.registerPhone({
                phoneNumber: values.phone || "",
            });
            if (res.data.message) {
                dispatch(setExternalLogin({ type: enumExternalMethod.TEL, isSignUp: true }));
                success(res.data.message);
                window.sessionStorage.setItem("phoneNumber", values?.phone || "");
                history.push(PATH_OTP);
            }
        } catch (errors: any) {
            const { message } = errors.response.data;
            error(message);
        } finally {
            setSubmitting(false);
            dispatch(setLoading(false));
        }
    };

    const { values, handleSubmit, isSubmitting, setFieldTouched, setFieldValue } = useFormik({
        initialValues: initialValues,
        onSubmit: handleRegister,
    });

    return (
        <ComponentSignUpTel
            values={values}
            handleSubmit={handleSubmit}
            isSubmitting={isSubmitting}
            setFieldTouched={setFieldTouched}
            setFieldValue={setFieldValue}
            errorPhone={errorPhone || ""}
            setError={setError}
        />
    );
};
